module.exports = __webpack_public_path__ + "static/media/3-1.f8b336cf.webp";